import { render, staticRenderFns } from "./AlimtalkMng.vue?vue&type=template&id=762d5456&scoped=true"
import script from "./AlimtalkMng.vue?vue&type=script&lang=js"
export * from "./AlimtalkMng.vue?vue&type=script&lang=js"
import style0 from "./AlimtalkMng.vue?vue&type=style&index=0&id=762d5456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762d5456",
  null
  
)

export default component.exports